import React, { useState } from "react";

const questions = [
  {
    id: 1,
    question:
      "This is a sample FAQ question for testing purposes. It should have sufficient length right?",
    answer: "Answer",
  },
  {
    id: 2,
    question:
      "This is a sample FAQ question for testing purposes. It should have sufficient length right? s is a sample FAQ question for testing purposes. It should have sufficient length ",
    answer: "Answer",
  },
  {
    id: 3,
    question:
      "This is a sample FAQ question for testing purposes. It should have sufficient length right?",
    answer: "Answer",
  },
  {
    id: 4,
    question:
      "This is a sample FAQ question for testing purposes. It should have sufficient length right?",
    answer: "Answer",
  },
  {
    id: 5,
    question:
      "This is a sample FAQ question for testing purposes. It should have sufficient length right?",
    answer: "Answer",
  },
  {
    id: 6,
    question:
      "This is a sample FAQ question for testing purposes. It should have sufficient length right?",
    answer: "Answer",
  },
  {
    id: 7,
    question:
      "This is a sample FAQ question for testing purposes. It should have sufficient length right?",
    answer: "Answer",
  },
  {
    id: 8,
    question:
      "This is a sample FAQ question for testing purposes. It should have sufficient length right?",
    answer: "Answer",
  },
];

const FAQ = ({data}) => {
  const [activeQuestionId, setActiveQuestionId] = useState(null);

  const toggleQuestion = (questionId) => {
    if (questionId === activeQuestionId) {
      setActiveQuestionId(null);
    } else {
      setActiveQuestionId(questionId);
    }
  };

  return (
    <div className="flex justify-center font-sans my-5">
      <div className="p-4 w-[90vw] bg-[#f1f1f1]  border-[1px] rounded-lg shadow-lg ">
        <div className="flex flex-row w-full justify-center items-center">
          <div className=" text-[50px] font-bold w-1/4 py-2 pl-8 pr-2 ">
            FAQs about {data}
          </div>
          <div className="w-3/4 px-5 py-2 items-center flex flex-col relative">
            {questions.map((q) => (
              <div className="my-3 w-3/4 mr-6 border-b-[1px] border-black ">
                <div
                  className="flex flex-row"
                  onClick={() => toggleQuestion(q.id)}
                >
                  <span className="mb-1 text-[16px] font-semibold">
                    {q.question}
                  </span>
                  {q.id === activeQuestionId ? (
                    <div className="ml-2 absolute right-32">
                      <i class="fa-solid fa-chevron-up"></i>
                    </div>
                  ) : (
                    <div className="ml-2 absolute right-32">
                      <i class="fa-solid fa-chevron-down"></i>
                    </div>
                  )}
                </div>
                {q.id === activeQuestionId && (
                  <div className="text-center text-[15px] ">{q.answer}</div>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default FAQ;
